import { Component } from '@angular/core';
import { StringWidget } from 'ngx-schema-form';

@Component({
	selector: 'g-custom-string-widget',
	templateUrl: './custom-string-widget.component.html',
	styleUrls: ['./custom-string-widget.component.scss'],
	standalone: false,
})
export class CustomStringWidgetComponent extends StringWidget {}
